export const capitalize = (s: string) => (s && s[0].toUpperCase() + s.slice(1)) || '';
export const trimmer = (s: string) => s.replace(/\s+$/, '');
export const replaceSpecialChar = (s: string | undefined) =>
    s ? trimmer(s).replace(/[^A-Z0-9]+/gi, '-') : '';
